import { render } from "./MyClubs.vue?vue&type=template&id=96768d06&ts=true"
import script from "./MyClubs.vue?vue&type=script&lang=ts"
export * from "./MyClubs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__